"use client";

import React, { Suspense } from "react";
import { enableMapSet } from "immer";
import useBridgeScannerFilterInit from "@/features/bridge-scanner/hooks/useBridgeScannerFilterCheck.hook";
import TableSwitchLiveMode from "@/features/bridge-scanner/components/switch-livemode";
import BridgeTransactionsTable from "@/features/bridge-scanner/components/table";

enableMapSet();

const BridgeScanner = () => {
  useBridgeScannerFilterInit();

  return (
    <Suspense>
      <TableSwitchLiveMode />
      <BridgeTransactionsTable />
    </Suspense>
  );
};

export default BridgeScanner;
